export default function SvgAngry() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 48 48"
        viewBox="0 0 48 48"
        width="30px"
        cursor="pointer"
      >
        <g>
          <linearGradient
            id="SVGID_1_"
            x1="24"
            x2="24"
            y1="8.212"
            y2="30.522"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#F45368"></stop>
            <stop offset="1" stopColor="#FFD872"></stop>
          </linearGradient>
          <circle cx="24" cy="24" r="12.244" fill="url(#SVGID_1_)"></circle>
          <circle
            cx="24"
            cy="24"
            r="12.244"
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          ></circle>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M15.152 24.523s2.007 1.636 6.996 1.584"
          ></path>
          <path
            fill="#303030"
            d="M19.505 25.962a1.1 1.1 0 01.272.723c0 .628-.5 1.13-1.129 1.13-.622 0-1.13-.502-1.13-1.13 0-.419.23-.78.572-.97l.479.099.936.148z"
          ></path>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M32.848 24.523s-2.007 1.636-6.996 1.584"
          ></path>
          <path
            fill="#303030"
            d="M29.91 25.714c.343.19.571.552.571.97 0 .63-.507 1.13-1.13 1.13-.627 0-1.128-.5-1.128-1.13a1.1 1.1 0 01.272-.722l1.415-.248z"
          ></path>
          <ellipse
            cx="24.129"
            cy="30.687"
            fill="#303030"
            rx="3.485"
            ry="0.488"
          ></ellipse>
        </g>
      </svg>
    </>
  );
}
